module.exports = __webpack_public_path__ + "static/media/servico-vibracall.57c87489.png";